var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-tabs',{staticClass:"mt-5 py-3",attrs:{"content-class":"mt-3"}},[_c('b-tab',{attrs:{"title":"Admin"}},[_c('adminMain',{attrs:{"user":_vm.user},on:{"showToast":_vm.showToast}})],1),_c('b-tab',{attrs:{"title":"Migrate ingredients"}},[_c('admin-migrate-recipes',{attrs:{"user":_vm.user,"ingredients":_vm.ingredients}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }